import { useSelector } from 'react-redux'

function TradingPairName({ pair }) {
	const { tradingPairs } = useSelector(state => state.cex)
	if (!tradingPairs) return null
	return tradingPairs && tradingPairs.find(tradingPair => tradingPair._id === pair).name
}

export default TradingPairName
